export default __webpack_public_path__ + "static/media/MediumSBAcceptableMovementEdited.591f8e89.mp4";